<script setup lang="ts">
import { MAX_LABELS, normalizeLabels } from '@/views/calculations/utils/quantityLabels'

const alias = defineModel<string>('alias', { required: true })
const labels = defineModel<string[]>('labels', { required: true })

withDefaults(
  defineProps<{
    name: string
    suggestions: string[]
    readonly?: boolean
    duplicate?: boolean
  }>(),
  { readonly: false, duplicate: false }
)
</script>

<template>
  <div class="source-row">
    <div class="text-caption text-medium-emphasis mb-1">{{ name }}</div>
    <v-row dense>
      <v-col cols="12" md="5">
        <v-text-field
          v-model="alias"
          label="Display name"
          density="comfortable"
          hide-details
          :readonly="readonly"
          :placeholder="name"
          :error="duplicate"
        />
      </v-col>
      <v-col cols="12" md="7">
        <v-combobox
          :model-value="labels"
          :items="suggestions"
          label="Add labels"
          multiple
          chips
          closable-chips
          clearable
          density="comfortable"
          hide-details="auto"
          :counter="MAX_LABELS"
          :readonly="readonly"
          @update:model-value="labels = normalizeLabels($event)"
        />
        <div class="text-caption text-medium-emphasis mt-1">
          Type to add a label (or pick one); the × removes it. This changes only
          <strong>this row's</strong> labels. To rename a label for everyone, use "Rename a label
          everywhere" above.
        </div>
      </v-col>
    </v-row>
  </div>
</template>
